/** Reusable visual components for the User Guide and help-content guideExtra blocks. */

export function Callout({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 mt-3">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-primary">
        {title}
      </p>
      {children}
    </div>
  );
}

export function RuleItem({
  code,
  severity,
  text,
}: {
  code: string;
  severity: "Critical" | "Warning";
  text: string;
}) {
  return (
    <div className="flex items-start gap-2">
      <span
        className={`mt-0.5 text-xs font-bold ${
          severity === "Critical" ? "text-red-400" : "text-purple-400"
        }`}
      >
        {code}
      </span>
      <span className="text-muted-foreground">{text}</span>
    </div>
  );
}
